import TipoArticuloStatusMessage from "common/components/StatusMessage/TipoArticuloStatusMessage"
import createImgURI from "common/utils/createImgURI"
import { formatCurrency } from "common/utils/currency"
import { ProgressSpinner } from "primereact/progressspinner"
import React from "react"
import { CameraOff } from "react-feather"
import { useTranslation } from "react-i18next"
import "./styles.scss"

const Articulo = React.memo(
  ({
    // @ts-expect-error TS(2339): Property 'concepto' does not exist on type '{}'.
    concepto,
    // @ts-expect-error TS(2339): Property 'thumbnailBase64' does not exist on type ...
    thumbnailBase64,
    // @ts-expect-error TS(2339): Property 'fichero' does not exist on type '{}'.
    fichero,
    // @ts-expect-error TS(2339): Property 'numeroReferencia' does not exist on type...
    numeroReferencia,
    // @ts-expect-error TS(2339): Property 'tipoArticulo' does not exist on type '{}...
    tipoArticulo,
    // @ts-expect-error TS(2339): Property 'precioVenta' does not exist on type '{}'...
    precioVenta,
    // @ts-expect-error TS(2339): Property 'sizeNoImageIcon' does not exist on type ...
    sizeNoImageIcon,
  }) => (
    <div className='articulo-catalogo'>
      <div className='wrap-left'>
        <div className='articulo-image'>
          {thumbnailBase64 ? (
            <img
              loading='lazy'
              src={createImgURI(thumbnailBase64, fichero?.mediaType)}
              alt={`Imagen del artículo ${concepto}`}
            />
          ) : (
            <CameraOff size={sizeNoImageIcon} />
          )}
        </div>

        <span className='articulo-referencia'>{numeroReferencia}</span>

        <span className='articulo-name'>{concepto}</span>
      </div>

      <div className='wrap-right'>
        <TipoArticuloStatusMessage
          outlined={false}
          tipoArticulo={tipoArticulo}
        />
        <span className='articulo-precio'>{formatCurrency(precioVenta)}</span>
      </div>
    </div>
  )
)

const CatalogoViewItems = ({
  categorias,
  loading,
  itemsLayout,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const thereAreArticulos = Object.keys(categorias).length

  return (
    <div className={`wrapCategorias ${itemsLayout ? "items-layout" : ""}`}>
      {!loading && !thereAreArticulos && (
        <h5 className='msg-no-articulos'>{t("catalogos.idView.noArticles")}</h5>
      )}

      {loading && (
        <ProgressSpinner
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      )}

      {Object.keys(categorias).map((categoriaName) => {
        const { articulos, totalCount } = categorias[categoriaName]
        return (
          <div
            key={categoriaName}
            className='categoria-container'
          >
            <span className='categoria-title'>
              {categoriaName} ({totalCount})
            </span>

            <div className='categoria-items'>
              {articulos.map((articulo: $TSMigrationFixMe) => (
                <Articulo
                  sizeNoImageIcon={itemsLayout ? 30 : 50}
                  key={articulo.id}
                  {...articulo}
                />
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default CatalogoViewItems
